const state = {
  inquiryList: {
    rows: [],
    meta: {},
    stats: { status_breakdown: [] }
  },
  inquiry: null
};

export default state;
